import React from 'react'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import {
  COLORS,
  COMMON_STYLES,
  CrossIcon,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'

type Props = {
  label: string
  onRemove: () => void
}

const RemovableFilterChip = ({ label, onRemove }: Props) => (
  <View style={styles.chip}>
    <Text style={styles.label} numberOfLines={1}>
      {label}
    </Text>
    <Pressable
      onPress={onRemove}
      style={({ pressed }) => [styles.removeBtn, pressed && COMMON_STYLES['opacity1/2']]}
      hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
    >
      <CrossIcon height={12} width={12} strokeColor="white" />
    </Pressable>
  </View>
)

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLORS.black,
    borderWidth: 1,
    borderColor: COLORS.black,
    borderRadius: 8,
    paddingLeft: 8,
    paddingRight: 4,
    paddingVertical: 4,
    marginRight: 4,
    flexShrink: 0,
  },
  label: {
    ...TYPOGRAPHY.TEXT2,
    ...VARIANTS_STYLES.BASE,
    color: COLORS.white,
    marginRight: 4,
    flexShrink: 1,
  },
  removeBtn: {
    paddingHorizontal: 4,
    paddingVertical: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
})

export default RemovableFilterChip
